module.exports = __webpack_public_path__ + "static/media/error-alert.c22964b9.svg";